import { openDesktopStudio } from "@/components/desktop/desktopApp";

//Stub functions
export const checkMediaPermissions = async () => true;

export const openSettings = () => {};

export const checkAllStreamingPermissions = async () => true;

export const requestStreamingPermissions = async () => {};

// In EventLive for Mac or Windows this opens the native Studio window (like
// the phone apps' camera screen); in a plain browser there is nothing to open.
export const openStreamWindow = async (event) => openDesktopStudio(event);

export const getAllPermissions = async () => {};

export const setForStream = () => {};
